import { Styles, css, extractShadow, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { CandidateFeedbackModalStyleProps } from './CandidateFeedbackModal.types';

const styles = {
  modalContent: () => css`
    min-width: 548px;
    max-width: 548px;
    border-radius: 12px;
    box-shadow: ${extractShadow((s) => s.robin2)};
  `,

  body: () => css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `,

  header: () => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  checkboxGroup: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: ${theme.colors.neutral.variant[70]};
    padding-left: 16px;
  `,

  checkbox: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[70]};
    margin-right: auto;
  `,

  textarea: css`
    min-height: 80px;
    resize: vertical;
    border-radius: 8px;
    font-size: 14px;

    & > textarea {
      min-height: 60px;
    }
  `,

  actions: () => css`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  `,
} satisfies Styles<CandidateFeedbackModalStyleProps>;

export const useStyles = withStyles(styles);
